export default "__VITE_ASSET__CrPAoIM6__"